import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { ColumnVisibilityModel, readAllStoredVisibility } from './columnVisibilityStorage';

interface ColumnSettingsState {
    isDialogOpen: boolean;
    overridesByGrid: Record<string, ColumnVisibilityModel>;
}

type StateWithColumnSettings = { columnSettings: ColumnSettingsState };

const NO_OVERRIDES: ColumnVisibilityModel = {};

/*
    The cache is read once at store creation rather than per grid, so no
    component has to deal with a hydration gap on first render.
*/
const initialState: ColumnSettingsState = {
    isDialogOpen: false,
    overridesByGrid: readAllStoredVisibility()
};

const columnSettingsSlice = createSlice({
    name: 'columnSettings',
    initialState,

    reducers: (create) => ({
        setColumnSettingsDialogOpen: create.reducer((state, action: PayloadAction<boolean>) => {
            state.isDialogOpen = action.payload;
        }),

        setColumnVisibilityOverrides: create.reducer((
            state,
            action: PayloadAction<{ gridKey: string, overrides: ColumnVisibilityModel }>
        ) => {
            state.overridesByGrid[action.payload.gridKey] = action.payload.overrides;
        }),

        clearColumnVisibilityOverrides: create.reducer((state, action: PayloadAction<string>) => {
            delete state.overridesByGrid[action.payload];
        })
    })
});

// eslint-disable-next-line no-restricted-syntax
export default columnSettingsSlice.reducer;
export const {
    clearColumnVisibilityOverrides,
    setColumnSettingsDialogOpen,
    setColumnVisibilityOverrides
} = columnSettingsSlice.actions;
export const selectIsColumnSettingsDialogOpen = (state: StateWithColumnSettings) => state.columnSettings.isDialogOpen;
export const selectColumnVisibilityOverrides = (gridKey: string) =>
    (state: StateWithColumnSettings): ColumnVisibilityModel =>
        state.columnSettings.overridesByGrid[gridKey] ?? NO_OVERRIDES;
